const applyForALoan = {
  namespaced: true,

  state: {
    // showApplyForALoanDialog
    showApplyForALoanDialog: false,

    // showMobileForm
    showMobileForm: false,

    // applyForALoanDialogStep
    applyForALoanDialogStep: 1,

    // amount

    amountMin: 0,
    amountInterval: 1,
    amountMax: 1,
    amount: 0,

    monthlyInterest: 0,

    // months
    months: 0,
    monthsMin: 0,
    monthsInterval: 1,
    monthsMax: 1,

    // interestRate
    interestRate: 5,
    interestRateMin: 0,
    interestRateInterval: 1,
    interestRateMax: 22,

    // includeInsurance
    includeInsurance: true,

    // emiPerMonth
    emiPerMonth: 377,

    // insuranceCover
    insuranceCover: 0,

    adminFee: 0,

    // paymentAmount
    paymentAmount: 6800.0,

    // bank
    bank: "",

    // bankAccountType
    bankAccountType: "",

    // cardNumber
    cardNumber: "",

    // expiryMonthAndYear
    expiryMonthAndYear: "",

    // cvc
    cvc: "",

    // nameOfEmployer
    nameOfEmployer: "",

    // employeeNameAndSurname
    employeeNameAndSurname: "",

    // idNumberEmployer
    idNumberEmployer: "",

    // mobileMoneyWalletNumberBank
    mobileMoneyWalletNumberBank: "",

    // mobileMoneyServiceProvider
    mobileMoneyServiceProvider: "",

    // referenceName
    referenceName: "",

    // stopOrderDate
    stopOrderDate: "",

    // Selected Loan Product ID
    loanProductId: null,
    // Product payback methods for the selected loan product
    productPaybackMethods: [],
  },

  mutations: {
    setSelectedLoanInitial(state) {
      state.amountMin = 0;
      state.amountMax = 1;
      state.amount = state.amountMin;

      state.months = 0;
      state.monthsMin = 0;
      state.monthsMax = 1;
    },

    setSelectedLoan(state, payload) {
      state.months = payload.numberOfRepayments;
      state.amount = payload.principal;
    },
    // setShowApplyForALoanDialog
    setShowApplyForALoanDialog(state, payload) {
      state.showApplyForALoanDialog = payload;
    },

    // setShowMobileForm
    setShowMobileForm(state, payload) {
      state.showMobileForm = payload;
    },

    // setApplyForALoanDialogStep
    setApplyForALoanDialogStep(state, payload) {
      state.applyForALoanDialogStep = payload;
    },

    // setAmount
    setAmount(state, payload) {
      state.amount = payload;
    },

    // setMonths
    setMonths(state, payload) {
      state.months = payload;
    },

    // setInterestRate
    setInterestRate(state, payload) {
      state.interestRate = payload;
    },

    setAdminFee(state, payload) {
      state.adminFee = payload;
    },

    setInitiationFee(state, payload) {
      state.initiationFee = payload;
    },

    // setIncludeInsurance
    setIncludeInsurance(state, payload) {
      state.includeInsurance = payload;
    },

    // setEmiPerMonth
    setEmiPerMonth(state, payload) {
      state.emiPerMonth = payload;
    },

    // setInsuranceCover
    setInsuranceCover(state, payload) {
      state.insuranceCover = payload;
    },

    // setPaymentAmount
    setPaymentAmount(state, payload) {
      state.paymentAmount = payload;
    },

    // setBank
    setBank(state, payload) {
      state.bank = payload;
    },

    // setBankAccountType
    setBankAccountType(state, payload) {
      state.bankAccountType = payload;
    },

    // setCardNumber
    setCardNumber(state, payload) {
      state.cardNumber = payload;
    },

    // setExpiryMonthAndYear
    setExpiryMonthAndYear(state, payload) {
      state.expiryMonthAndYear = payload;
    },

    // setCvc
    setCvc(state, payload) {
      state.cvc = payload;
    },

    // setNameOfEmployer
    setNameOfEmployer(state, payload) {
      state.nameOfEmployer = payload;
    },

    // setEmployeeNameAndSurname
    setEmployeeNameAndSurname(state, payload) {
      state.employeeNameAndSurname = payload;
    },

    // setIdNumberEmployer
    setIdNumberEmployer(state, payload) {
      state.idNumberEmployer = payload;
    },

    // setMobileMoneyWalletNumberBank
    setMobileMoneyWalletNumberBank(state, payload) {
      state.mobileMoneyWalletNumberBank = payload;
    },

    // setMobileMoneyServiceProvider
    setMobileMoneyServiceProvider(state, payload) {
      state.mobileMoneyServiceProvider = payload;
    },

    // setReferenceName
    setReferenceName(state, payload) {
      state.referenceName = payload;
    },

    setStopOrderDate(state, payload) {
      state.stopOrderDate = payload;
    },

    // setLoanProductId
    setLoanProductId(state, payload) {
      state.loanProductId = payload;
    },

    // setProductPaybackMethods
    setProductPaybackMethods(state, payload) {
      state.productPaybackMethods = Array.isArray(payload) ? payload : [];
    },

    clearCalculator(state) {
      state.amount = 500;

      state.months = 1;
    },

    resetState(state) {
      state.showApplyForALoanDialog = false;

      state.showMobileForm = false;

      state.applyForALoanDialogStep = 1;

      state.amountMin = 0;
      state.amountInterval = 1;
      state.amountMax = 1;
      state.amount = 0;

      state.months = 0;
      state.monthsMin = 0;
      state.monthsInterval = 1;
      state.monthsMax = 1;

      state.interestRate = 5;
      state.interestRateMin = 0;
      state.interestRateInterval = 1;
      state.interestRateMax = 22;

      state.includeInsurance = true;

      state.emiPerMonth = 377;

      state.insuranceCover = 0;

      state.paymentAmount = 6800.0;

      state.bank = "";

      state.bankAccountType = "";

      state.cardNumber = "";

      state.expiryMonthAndYear = "";

      state.cvc = "";

      state.nameOfEmployer = "";

      state.employeeNameAndSurname = "";

      state.idNumberEmployer = "";

      state.mobileMoneyWalletNumberBank = "";

      state.mobileMoneyServiceProvider = "";

      state.referenceName = "";

      state.stopOrderDate = "";
    },
  },

  actions: {},

  getters: {
    calculateEmiPerMonth(state) {
      const principal = Number(state.amount) || 0;
      const numberOfPayments = Number(state.months) || 0;

      const adminFee = Number(state.adminFee) || 0; // monthly amount
      const insuranceCover = Number(state.insuranceCover) || 0; // monthly amount

      console.log("adminFee", adminFee);
      console.log("insuranceCover", insuranceCover);

      const monthlyInterestRate = (Number(state.interestRate) || 0) / 100;

      // Total fees per month
      const monthlyFees = adminFee + insuranceCover;

      // Total principal + interest portion per month using flat interest
      // Compute interest on full principal, then distribute equally
      const monthlyInterest = principal * monthlyInterestRate;

      // Monthly principal = total principal / months
      const monthlyPrincipal = principal / numberOfPayments;

      // Total monthly payment = principal + interest + fees
      const monthlyPayment = monthlyPrincipal + monthlyInterest + monthlyFees;

      console.log("monthlyPrincipal", monthlyPrincipal);
      console.log("monthlyInterest", monthlyInterest);
      console.log("monthlyFees", monthlyFees);
      console.log("monthlyPayment", monthlyPayment);

      return monthlyPayment;
    },

    getTotalFees(state) {
      let monthlyFees = state.insuranceCover + state.adminFee;
      let total = state.initiationFee + monthlyFees * state.months;
      return total;
    },

    calculatePaymentAmount(state, getters) {
      return getters.calculateEmiPerMonth * state.months;
    },

    getTotalInterest(state) {
      const principal = Number(state.amount) || 0;
      const numberOfPayments = Number(state.months) || 0;
      const monthlyInterestRate = (Number(state.interestRate) || 0) / 100;

      const monthlyInterest = principal * monthlyInterestRate;
      const totalInterest = monthlyInterest * numberOfPayments;

      return totalInterest;
    },

    // getShowApplyForALoanDialog
    getShowApplyForALoanDialog(state) {
      return state.showApplyForALoanDialog;
    },

    // getShowMobileForm
    getShowMobileForm(state) {
      return state.showMobileForm;
    },

    // getApplyForALoanDialogStep
    getApplyForALoanDialogStep(state) {
      return state.applyForALoanDialogStep;
    },

    // getAmount
    getAmount(state) {
      return state.amount;
    },

    // getMonths
    getMonths(state) {
      return state.months;
    },

    // getInterestRate
    getInterestRate(state) {
      return state.interestRate;
    },

    // getIncludeInsurance
    getIncludeInsurance(state) {
      return state.includeInsurance;
    },

    // getEmiPerMonth
    getEmiPerMonth(state) {
      return state.emiPerMonth;
    },

    // getInsuranceCover
    getInsuranceCover(state) {
      return state.insuranceCover;
    },

    getAdminFee(state) {
      return state.adminFee;
    },

    getInitiationFee(state) {
      return state.initiationFee;
    },

    // getPaymentAmount
    getPaymentAmount(state) {
      return state.paymentAmount;
    },

    // getBank
    getBank(state) {
      return state.bank;
    },

    // getBankAccountType
    getBankAccountType(state) {
      return state.bankAccountType;
    },

    // getCardNumber
    getCardNumber(state) {
      return state.cardNumber;
    },

    // getExpiryMonthAndYear
    getExpiryMonthAndYear(state) {
      return state.expiryMonthAndYear;
    },

    // getCvc
    getCvc(state) {
      return state.cvc;
    },

    // getNameOfEmployer
    getNameOfEmployer(state) {
      return state.nameOfEmployer;
    },

    // getEmployeeNameAndSurname
    getEmployeeNameAndSurname(state) {
      return state.employeeNameAndSurname;
    },

    // getIdNumberEmployer
    getIdNumberEmployer(state) {
      return state.idNumberEmployer;
    },

    // getMobileMoneyWalletNumberBank
    getMobileMoneyWalletNumberBank(state) {
      return state.mobileMoneyWalletNumberBank;
    },

    // getMobileMoneyServiceProvider
    getMobileMoneyServiceProvider(state) {
      return state.mobileMoneyServiceProvider;
    },

    // getReferenceName
    getReferenceName(state) {
      return state.referenceName;
    },

    // getStopOrderDate
    getStopOrderDate(state) {
      return state.stopOrderDate;
    },
  },
};

export default applyForALoan;
